"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      title: 'Vue Element Admin',
      logo: 'https://wpimg.wallstcn.com/69a1c46c-eb1c-4b46-8bd4-e9e686ef5251.png'
    };
  },
  computed: {
    isInIframe: function isInIframe() {
      return window.self !== window.top;
    },
    path: function path() {
      if (this.$store.getters.orgGroup == "ROOT") {
        return "/dashboard";
      } else {
        return "/power_station/power_station_list";
      }
    }
  }
};